@if (!data?.mediasSlider && data?.media && layout !== argumentsLayoutEnum.divided) {
  <sd-banner
    [isComponentLoading]="isLoading"
    [media]="data?.media"
    [videoTitle]="data?.content?.heading?.data?.title"
    [buttonPosition]="null"
    [isAriaHidden]="true"
    (mediaPlay)="onVideoPlayed()"
    (mediaEnded)="onVideoEnded()"
    [ngStyle]="{'height': imageAbsolute}"
    [imgRatio]="layout === argumentsLayoutEnum.default ? ratioEnum.default : isMobile$ ? layout === argumentsLayoutEnum.embedded ? ratioEnum.r9_19 : ratioEnum.r4_3 : ratioEnum.r21_9"
    class="is-main"
    #mediaBackground
    [attr.data-swiper-parallax]="-50"
    [attr.data-swiper-parallax-opacity]="0.2"
    [twicPicsAutoSize]="twicPicsAutoSize"
  />
}

@if (data?.mediasSlider && !data?.media && layout !== argumentsLayoutEnum.divided) {
  @for (media of data?.mediasSlider; track media) {
    <sd-banner
      [isComponentLoading]="isLoading"
      [media]="media"
      [videoTitle]="data?.content?.heading?.data?.title"
      #mediasInnerSlider
      [imgRatio]="isMobile$ ? layout === argumentsLayoutEnum.embedded ? ratioEnum.r9_19 : ratioEnum.r4_3 : layout === argumentsLayoutEnum.default ? ratioEnum.r16_9 : ratioEnum.r21_9"
      (mediaPlay)="onVideoPlayed()"
      (mediaEnded)="onVideoEnded()"
      [isAriaHidden]="true"
      [ngStyle]="{'height': imageAbsolute}"
      class="is-main is-inner-slider {{activeIndex !== $index ? 'is-visually-hidden' : ''}}"
      #mediaBackground
      [twicPicsAutoSize]="twicPicsAutoSize"
    />
  }
}

<div class="c__content" #contentWrapper [ngStyle]="{'height': imageAbsolute}">
  <sd-rich-paragraph
    [isLoading]="isLoading"
    [brand]="brand"
    [class]="embeddedOpacity ? 'has-opacity-' + embeddedOpacity : ''"
    [contentData]="data?.content"
    [isDescription]="isDescription"
    [size]="isDesktopLarge$ ? sizesEnum.xl : sizesEnum.l"
    #richParagraph
    [titleLevel]="titleLevel"
    [hasMediasLinksThumbnails]="!!data?.mediasSlider"
    (clicked)="onClick($event)"
    [parentsThemesConfig]="themesConfig"
    [textConfig]="textConfig"
    [attr.data-swiper-parallax]="-100"
    [attr.data-swiper-parallax-opacity]="0"
  />

  @if (data?.mediasSlider && !data?.secondaryMedia && layout !== argumentsLayoutEnum.embedded && layout !== argumentsLayoutEnum.default) {
    @for (media of data?.mediasSlider; track media) {
      <sd-banner
        [isComponentLoading]="isLoading"
        class="{{activeIndex !== $index ? 'is-visually-hidden' : ''}}"
        #mediasInnerSlider
        [hasAltText]="false"
        [hasModal]="true"
        [media]="media"
        [videoTitle]="data?.content?.heading?.data?.title"
        (mediaPlay)="onVideoPlayed()"
        (mediaEnded)="onVideoEnded()"
        [attr.data-swiper-parallax]="-50"
        [attr.data-swiper-parallax-opacity]="0.2"
        [twicPicsAutoSize]="twicPicsAutoSize"
      />
    }
  }

  @if (!data?.mediasSlider && data?.secondaryMedia && layout !== argumentsLayoutEnum.embedded) {
    <sd-banner
      [isComponentLoading]="isLoading"
      [media]="data?.secondaryMedia"
      [videoTitle]="data?.content?.heading?.data?.title"
      [hasAltText]="false"
      [hasModal]="true"
      (mediaPlay)="onVideoPlayed()"
      (mediaEnded)="onVideoEnded()"
      [imgRatio]=" layout === argumentsLayoutEnum.divided ? ratioEnum.default : isMobile$ ? ratioEnum.r4_3 : ratioEnum.r16_9"
      [attr.data-swiper-parallax]="-50"
      [attr.data-swiper-parallax-opacity]="0.2"
      [twicPicsAutoSize]="twicPicsAutoSize"
    />
  }
</div>
